module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07.2b0ba4a4.jpg";